import mendeleev from "@/urls/mendeleev"
import {
  sendGetRequest,
} from "@/helper/requests"

const state = {
  news: {
    currentUrl: null,
    items: [],
    loading: false,
    count: 0,
    detail: [],
    next: null,
    prev: null,
    error: null,
  }
}

const getters = {
  getNews: state => state.news.items,
  getNewsCount: state => state.news.count,
  getNewsCurrentUrl: state => state.news.currentUrl,
  getNewsNext: state => state.news.next,
  getNewsPrev: state => state.news.prev,
  getNewsDetail: state => state.news.detail,
  isLoadingNews: state => state.news.loading,
  saveNewsError: state => state.news.error,
}

const actions = {
  loadNews: ({ commit, getters }, { url, urlAppend, finalizer = () => {}, catcher = () => {} }) => {
    if (!url) {
      url = mendeleev.USER.INFOS.NEWS.LIST()
      if (urlAppend) url = urlAppend(url)
    }
    if (!getters.isLoadingNews) {
      commit('SET_NEWS_LOADING')
      sendGetRequest(
        url, (data, url) => {
          commit('SET_NEWS', data)
          commit('SET_NEWS_COUNT', data.count)
          commit('SET_NEWS_CURRENT_URL', url)
          commit('SET_NEWS_NEXT_URL', data.next)
          commit('SET_NEWS_LOADING_END')
          finalizer(data, url)
        }, (data, url) => {
          commit('SET_NEWS_LOADING_END')
          commit('SAVE_NEWS_ERROR', data)
          catcher(data, url)
        }
      )
    }
  },
  // loadNewsDetail: ({commit}, {url, id, finalizer=()=>{}, catcher=()=>{}}) => {
  //   if (!url) url = url = mendeleev.USER.PARTNERS.NEWS.DETAIL(id)
  //   sendGetRequest(
  //     url, (data, url) => {
  //       commit('SET_NEWS_DETAIL', data);
  //       finalizer(data, url);
  //     }, (data, url) => {
  //       commit('SAVE_NEWS_ERROR', data);
  //       catcher(data, url);
  //     }
  //   )
  // },
}

const mutations = {
  SET_NEWS: (state, value) => {
    state.news.items = value
  },
  SET_NEWS_DETAIL: (state, value) => {
    state.news.detail = value
  },
  SET_NEWS_COUNT: (state, value) => {
    state.news.count = value
  },
  SET_NEWS_CURRENT_URL: (state, value) => {
    state.news.currentUrl = value
  },
  SET_NEWS_NEXT_URL: (state, value) => {
    state.news.next = value
  },
  SET_NEWS_PREV_URL: (state, value) => {
    state.news.prev = value
  },
  SET_NEWS_LOADING: (state) => {
    state.news.loading = true
  },
  SET_NEWS_LOADING_END: (state) => {
    state.news.loading = false
  },
  SAVE_NEWS_ERROR: (state, error) => {
    state.news.error = error
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
